import React from "react";
import { useTheme } from "@/lib/theme";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Moon, Sun } from "lucide-react";

export default function ThemeSwitcher({ inline = false }) {
  const { theme, setTheme, mode, toggleMode, themes } = useTheme();
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-sm font-semibold heading">Appearance &amp; Theme</div>
          <div className="text-xs text-muted-foreground">Pick a color theme. Saffron applies the national palette.</div>
        </div>
        <Button variant="outline" size="sm" onClick={toggleMode} data-testid="theme-mode-toggle">
          {mode === "light" ? <><Moon className="h-3.5 w-3.5 mr-1" />Dark</> : <><Sun className="h-3.5 w-3.5 mr-1" />Light</>}
        </Button>
      </div>
      <div className={`grid grid-cols-2 ${inline ? "sm:grid-cols-3" : "sm:grid-cols-3 lg:grid-cols-6"} gap-2`}>
        {Object.entries(themes).map(([key, t]) => (
          <button
            type="button"
            key={key}
            onClick={() => setTheme(key)}
            className={`group relative text-left rounded-md p-3 border transition-all ${theme === key ? "border-accent ring-2 ring-accent/30" : "border-border hover:border-accent/40"}`}
            data-testid={`theme-option-${key}`}
          >
            <div className="flex items-center gap-1.5 mb-2">
              <ThemePreview tokens={t.light} />
              <span className="text-base">{t.icon}</span>
            </div>
            <div className="text-xs font-medium leading-snug">{t.label}</div>
            <div className="text-[10px] text-muted-foreground mt-0.5 leading-tight">{t.description}</div>
            {theme === key && (
              <CheckCircle2 className="h-4 w-4 text-accent absolute top-2 right-2" />
            )}
          </button>
        ))}
      </div>
    </div>
  );
}

function ThemePreview({ tokens }) {
  return (
    <div className="flex items-center -space-x-1">
      <div className="h-4 w-4 rounded-full border border-white/40" style={{ backgroundColor: `hsl(${tokens.primary})` }} />
      <div className="h-4 w-4 rounded-full border border-white/40" style={{ backgroundColor: `hsl(${tokens.accent})` }} />
    </div>
  );
}
